import React, { useState, useRef, useEffect } from "react";

import styles from "../styles/CharacterView.module.css";
import { useParams } from "react-router-dom";

import useApi from "../hooks/useApi";
import VariantGrid from "../components/VariantGrid";
import PromptInputs from "../components/PromptInputs";
import DropdownCharacterList from "../components/DropdownCharacterList";

const CharacterView = () => {
  const { id } = useParams();
  const { get } = useApi();

  const [loading, setLoading] = useState(true);
  const [prompt, setPrompt] = useState("");
  
  // const [midMenu, setMidMenu] = useState(0);
  // const [variant, setVariant] = useState(null);
  // const viewerRef = useRef(null);
  // const [character, setCharacter] = useState(null);

  return (
    <div className={styles.appContent}>
      <PromptInputs
        prompt={prompt}
        loading={loading}
      />

      <div className={styles.midMenu}>
          <VariantGrid
            id={id}
            updatePrompt={setPrompt}
          />
      </div>

      {/* <div className={styles.rightMenu}></div> */}

      <DropdownCharacterList />
    </div>
  );
};

export default CharacterView;
